<template lang="pug">
    #dashboardPage(:class="{ 'db2-lock': currentView === 'dashboard' }")
        Navbar(
            v-if="shouldShowNavbar" 
            tab="dashboard" 
            :siteId="navbarSiteId" 
            :zoneId="zoneId" 
            :site="site" 
            :scoreHelp="scoreHelp"
        )
        
        // Dashboard Management Views - now with navbar visible
        DashboardSelection(
            v-if="currentView === 'selection' && !dashboardId"
            @select-dashboard="handleSelectDashboard"
            @create-new="showCreateDashboardModal = true"
        )
        
        CreateDashboard(
            :dialog="showCreateDashboardModal"
            @update:dialog="showCreateDashboardModal = $event"
            @create-dashboard="handleCreateDashboard"
            @close="showCreateDashboardModal = false"
        )
        
        DashboardWorkspace(
            v-if="currentView === 'dashboard' && selectedDashboard"
            :dashboard="selectedDashboard"
            :initialEditMode="isNewDashboard"
            @back="handleBackToSelection"
            @saved="onDashboardSaved"
            @cleared-new="isNewDashboard = false"
            @create-new="showCreateDashboardModal = true"
        )
        
        // Dashboard Not Found View
        div(v-if="currentView === 'notFound'")
            v-container
                v-row
                    v-col
                        .empty-card(style="text-align: center; padding: 60px;")
                            v-icon(size="64" style="color: var(--app-tertiary-txt)") mdi-alert-circle
                            h3.mt-4(style="color: var(--app-primary-txt)") Dashboard Not Found
                            p(style="color: var(--app-tertiary-txt)") No dashboard with Id={{ dashboardId }} exists
                            v-btn(@click="handleBackToSelection" color="primary" class="mt-4") Back to Dashboards
        
        // Original Site Monitoring View
        main(v-if="ready && currentView === 'monitoring'")
            v-btn(elevation="2" fab bottom right color="var(--primary-alert)" fixed @click="$store.commit('toggleEditMode')" v-if="$store.state.user.role == 'admin' || $store.state.user.role == 'superAdmin'")
                v-icon(v-show="!$store.state.editMode") mdi-pencil
                v-icon(v-show="$store.state.editMode") mdi-close
            v-snackbar(v-model="snackbar" top right) {{snackMsg}}
                template(v-slot:action="{ attrs }")
                    v-icon.close-icon(text @click="snackbar=false") mdi-close				
            v-container(v-if="site && hasAccess")
                v-row.align-center.my-1
                        v-col(:cols="12" :md="6" :sm="12").align-center.d-flex
                            AppBreadcrumbs(label="Dashboards" :site="site" :site-id="siteId" :show-site="true")
                                template(v-if="zoneCrumbs && zoneCrumbs.length")
                                    span(v-for="(b,index) in zoneCrumbs" :key="'dz-'+index")
                                        v-icon mdi-chevron-right
                                        span {{b.name}}
                        v-col(:cols="12" :md="6" :sm="12").d-flex.justify-end.align-center
                            v-switch(v-model="floorPlanView" v-if="floorPlanViewAvailable" style="max-height:33px").ma-0
                                template(v-slot:label)
                                    span(style="color:var(--app-primary-txt)") Floorplan View
                            .date-range(v-show="timePeriod != 'custom'" style="margin-left:63px") {{ dateRange }}
                v-row.site-header.no-flex
                    v-col.m12.l6.site-info
                        .site-image(:style='"background-image:url(" + (site.logo ? site.logo.url.replace("http", "https") : "") + ")"')
                        .site-progress(v-if="pageTitle.score && site.aqEnabled == true")
                            TooltipsSite(v-if="tooltipCount === 1 && site.aqEnabled == true" :id=0 name="site progress" position="bottom" arrowAlignment="left" message="Click this radial to see how the score is calculated." @next="advanceOnboardingTooltip")
                            a.modal-trigger(v-if="pageTitle.score" href="#modal-score-breakdown" style="color:var(--app-tertiary-txt)")
                                DonutIndicator(:key="pageTitle.id+'-pt-donut'" :id="pageTitle.id +'-scoreOA'" :cssClass="'main-donut'" :value="Math.round(pageTitle.score)" :size="60" v-if="site.aqEnabled !== false")
                            //- DonutIndicator(v-else :key="pageTitle.id+'-pt-donut'" :id="pageTitle.id +'-scoreOA'" :cssClass="'main-donut'" :value="Math.round(pageTitle.score)" :size="60")
                        .site-title(style="display:flex;flex-direction:column;")
                            router-link(:to="{name: 'Site', params: {projectId: projectId, siteId: siteId}}").siteLink {{pageTitle.title}}
                            div(v-if="projectId&&projectId=='pwNeghwfDaNcSlOApelIYmA6'")
                                a.modal-trigger(href="#modal-airnow" style="color:var(--app-tertiary-txt)")
                                    span EPA AirNow AQI
                    v-col.m12.l6
                        .site-filter
                            .site-filter-ddl
                                .vuetify(data-app)
                                    HaqSelect(v-model="scope" :items="scopeZones" item-text="name" item-value="objectId" label="Zone" @change="loadZone" hide-details
                                        :menu-props="{ bottom: true, offsetY: true, closeOnClick: true, closeOnContentClick: true, }")
                            .site-filter-ddl
                                .vuetify(data-app)
                                    HaqSelect(v-model="timePeriod" :items="timePeriods" item-text="name" item-value="value" label="Time Period" hide-details disabled=(viewOnly?'true':null)
                                        :menu-props="{ bottom: true, offsetY: true, closeOnClick: true, closeOnContentClick: true, }")
                        .time-period(v-show="timePeriod === 'custom'")
                            .tp-input
                                label(for='dpStart') Starting Date
                                input.datepicker.start-date(ref='dpStart',name='dpStart',autocomplete='off',@change='setCustomTimePeriod')
                            .tp-input
                                label(for='dpEnd') Ending Date
                                input.datepicker.end-date(ref='dpEnd',name='dpEnd',autocomplete='off',@change='setCustomTimePeriod')
                TooltipsSite(v-if="tooltipCount === 0 && !zoneId" :id=1 name="zone button" position="top" arrowAlignment="center" message="Click this card to navigate into a zone." @next="advanceOnboardingTooltip")
                //- No cards?
            v-container(v-else-if="!site && hasAccess")
                v-row
                    v-col
                        .empty-card There are no measurements for this site.
            v-container(v-else-if="!hasAccess")
                v-row
                    v-col
                        .empty-card Sorry, you do not have access to that project. Please contact your site administrator to request access.
        footer(v-if="currentView === 'monitoring'")
            .container
                v-row
                    v-col.s12
                        span.powered(v-if="whitelabel") {{whitelabel}}
        ScoreBreakdownModal(:overallCurScore="pageTitle.score",:measurements="helpMeasurements" :key="helpMeasurements.length+1" v-if="pageTitle.score")
        AirNowModal(v-if="true")
</template>
<script>
import Navbar from '@/components/Navbar.vue';
import DonutIndicator from '@/components/DonutIndicator.vue';
import AqCard from '@/components/AqCard.vue';
import moment from 'moment';
import {HTTPClient} from '../assets/js/http';
import ScoreBreakdownModal from '@/components/help/scoreBreakdown/ScoreBreakdownModal';
import AirNowModal from '@/components/AirNowModal';
import TooltipsSite from '@/components/NewUserOnboarding/TooltipsSite.vue'
import {wlData} from '../assets/js/constants';
import DashboardSelection from '@/components/dashboard/DashboardSelection.vue';
import CreateDashboard from '@/components/dashboard/CreateDashboard.vue';
import DashboardWorkspace from '@/components/dashboard/v2/DashboardWorkspace.vue';
import {useGetSite} from '../assets/js/hawken-query'
import { firstAccessibleSite, sitesUserCanAccess } from '../assets/js/siteAccess';
import { dashboardSiteQuery } from '@/components/dashboard/v2/dashboardModel';
import FloorPlanView from './FloorPlan.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import HaqSelect from '@/components/form/HaqSelect.vue'
let client = new HTTPClient();

export default {
    name: 'Dashboard',
    components: {
		Navbar,
		DonutIndicator,
		AqCard,
		ScoreBreakdownModal,
        AirNowModal,
		TooltipsSite,
		FloorPlanView,
		DashboardSelection,
		CreateDashboard,
		DashboardWorkspace,
		AppBreadcrumbs,
		HaqSelect
    },
    data(){
        return {
			// Dashboard Management State
			currentView: this.$route.params.dashboardId ? 'dashboard' : 'selection',
			selectedDashboard: null,
			isNewDashboard: false,
			dashboardId: this.$route.params.dashboardId || null,
			showCreateDashboardModal: false,
			
			// Existing Site Monitoring State
			ready: false,
			projectId: this.$route.params.projectId || this.$store.state.project?.objectId || null,
			siteId: this.$route.params.siteId || this.$route.query.siteId,
			zoneId: this.$route.params.zoneId,
			hasAccess: true,
			loadingProjects: false,			
			site: null,
			zone: null,
			siteLogo: '',
			zones: null,
			measurementsAF: null,
			measurementsAQ: null,
			measurementsOW: null,
			measurementsEQ: null,
			scope: this.$route.params.zoneId ? this.$route.params.zoneId : 'overview',
			scopeZones: null,
            floorPlanViewAvailable: false,
            floorPlanView: false,
			timePeriod: 'week',
			timePeriods: [
				{'name':'Today','value':'day'},
				{'name':'This Week','value':'week'},
				{'name':'This Month','value':'month'},
				{'name':'Custom','value':'custom'}
			],
			tpCustomStart: moment().startOf('week').valueOf(),
			tpCustomEnd: moment().valueOf(),
			zoneCrumbs: [],
			pageTitle: {
				id: "",
				score: 0,
				title: "",
			},
			helpMeasurements: [],
			whitelabel: this.$store.state.project?.whitelabel?wlData.poweredByFooter:'',
			zoneTracker: {},
			tooltipCount: null,
			newSensor: false,
			notifications: {
				alerts: [],
				cssClass: null,				
			},
			scoreHelp: {
				overallCurScore: null,
				measurements: null,
				key: null,
			},
			activeDialog: null,
			snackbar: false,
			snackMsg: '',
			
			// NEW: Alerting data management
			dashboardAlertingData: {}, // siteId+zoneId → measurements with alerts
			pointToMeasurementMap: {}, // pointId → { measurementId, alerts: [], isAlerting: boolean }
			alertingDataLoaded: false,
			alertingDataLoading: false
		};
	},
	methods: {
		// Dashboard Management Methods
		async handleSelectDashboard(dashboardId) {
			try {
				const dashboard = (this.$store.state.dashboards || []).find(d => d.objectId === dashboardId);
				// Navigate to the dashboard detail route
				this.$router.push({
					name: 'DashboardDetail', 
					params: { 
						projectId: this.projectId, 
						dashboardId: dashboardId 
					},
					query: dashboardSiteQuery(dashboard)
				});
			} catch (error) {
				console.error('Failed to navigate to dashboard:', error);
				window.M.toast({html: 'Failed to navigate to dashboard'});
			}
		},
		async handleCreateDashboard(dashboard) {
			try {
				if (!dashboard || !dashboard.objectId) {
					throw new Error('Create dashboard returned no id');
				}
				this.isNewDashboard = true;
				this.$router.push({
					name: 'DashboardDetail',
					params: {
						projectId: this.projectId,
						dashboardId: dashboard.objectId
					},
					query: dashboardSiteQuery(dashboard, { new: '1' })
				});
			} catch (error) {
				console.error('Failed to handle dashboard creation:', error);
				window.M.toast({html: 'Failed to navigate to dashboard'});
			}
		},
		handleCardClick(card) {
			console.log('Card clicked:', card);
			// Handle card navigation - could navigate to zones or other dashboards
			if (card.linkType === 'zone') {
				// Navigate to zone monitoring view
				this.currentView = 'monitoring';
				// Set up zone-specific data
			}
		},
		
		/**
		 * Keep the view-mode dashboard in sync after Save.
		 * @param {object} dashboard
		 */
		onDashboardSaved(dashboard) {
			if (!dashboard) return;
			this.selectedDashboard = dashboard;
			this.isNewDashboard = false;
		},
		handleBackToSelection() {
			// Check if we're already on the dashboard list route
			const currentRoute = this.$route;
			const targetRoute = {
				name: 'Dashboard', 
				params: { 
					projectId: this.projectId 
				},
				query: {
					siteId: this.siteId
				}
			};
			
			// Only navigate if we're not already on the target route
			if (currentRoute.name !== targetRoute.name || 
				currentRoute.params.projectId !== targetRoute.params.projectId ||
				currentRoute.params.dashboardId) {
				this.$router.push(targetRoute);
			} else {
				// If we're already on the dashboard list, just reset the view state
				this.currentView = 'selection';
				this.selectedDashboard = null;
				this.isNewDashboard = false;
			}
		},
		
		async loadDashboard() {
			try {
				// Fetch the dashboard by ID using store action
				const result = await this.$store.dispatch('getDashboard', this.dashboardId);
				if (result.results) {
					this.selectedDashboard = result.results;
					this.currentView = 'dashboard';
					this.isNewDashboard = this.$route.query.new === '1';
					this.loadSite();
				} else {
					// Dashboard not found
					this.currentView = 'notFound';
				}
			} catch (error) {
				console.error('Failed to load dashboard:', error);
				this.currentView = 'notFound';
			}
		},
		
		// NEW: Alerting data loading methods
		async loadDashboardAlertingData() {
			if (this.alertingDataLoaded || this.alertingDataLoading) return;
			
			this.alertingDataLoading = true;
			
			try {
				const siteZonePairs = this.getSiteZonePairs();
				
				if (siteZonePairs.length === 0) {
					this.alertingDataLoaded = true;
					return;
				}
				
				// Load measurements for each site/zone pair in parallel
				const measurementsPromises = siteZonePairs.map(async (pair) => {
					const [siteId, zoneId] = pair.split(':');
					const measurements = await this.loadMeasurementsForSiteZone(siteId, zoneId);
					return { siteId, zoneId, measurements };
				});
				
				const allMeasurements = await Promise.all(measurementsPromises);
				
				// Build lookup tables
				this.buildAlertingLookupTables(allMeasurements);
				
				this.alertingDataLoaded = true;
			} catch (error) {
				console.error('Failed to load dashboard alerting data:', error);
			} finally {
				this.alertingDataLoading = false;
			}
		},
		
		buildAlertingLookupTables(allMeasurements) {
			// Clear existing data
			this.dashboardAlertingData = {};
			this.pointToMeasurementMap = {};
			
			allMeasurements.forEach(({ siteId, zoneId, measurements }) => {
				const key = `${siteId}:${zoneId}`;
				this.dashboardAlertingData[key] = measurements;
				
				// Build point-to-measurement mapping
				measurements.forEach(measurement => {
					if (measurement.childPoints && Array.isArray(measurement.childPoints)) {
						measurement.childPoints.forEach(childPoint => {
							this.pointToMeasurementMap[childPoint.objectId] = {
								measurementId: measurement.objectId,
								alerts: measurement.alerts || [],
								isAlerting: measurement.alerts && measurement.alerts.length > 0
							};
						});
					}
				});
			});
		},
		
		getSiteZonePairs() {
			if (!this.selectedDashboard || !this.selectedDashboard.cards) {
				return [];
			}
			
			return [...new Set(
				this.selectedDashboard.cards
					.filter(c => c.siteId && c.zoneId)
					.map(c => `${c.siteId}:${c.zoneId}`)
			)];
		},
		
		async loadMeasurementsForSiteZone(siteId, zoneId) {
			try {
				const result = await client.robustQuery('/api/measurements', { 
					siteId, 
					zoneId
				});
				return result.results || [];
			} catch (error) {
				console.error(`Failed to load measurements for site ${siteId}, zone ${zoneId}:`, error);
				return []; // Return empty array on error
			}
		},
		
		// Existing Methods
        closeModal() {
			this.activeDialog = null;
		},
		startOnboardingTooltips(){
			let user = this.$store.state.user;
			let count = user.onboardingComplete?.tooltips ? Object.keys(user.onboardingComplete?.tooltips).length : 0;
			this.tooltipCount = count;
		},
		advanceOnboardingTooltip(){
			this.tooltipCount++;
		},
		getAlertCssClass(){
			let criticalCount = 0;
			let warningCount = 0;
			this.notifications.alerts.forEach(a => {
				if (a.alertConfig.alertType === 'critical')
					criticalCount++;
				else if(a.alertConfig.alertType === 'warning')
					warningCount++;
			})
			if (criticalCount)
				this.notifications.cssClass = 'msmt-alarm msmt-critical';
			else if(warningCount)
				this.notifications.cssClass = 'msmt-alarm msmt-warning';
		},
		loadZone(zoneId) {
			if(zoneId === "overview") {
				this.zoneId = null;
				let projectId = this.projectId;
				let siteId = this.siteId;
				this.$router.push({name: 'Site', params: {projectId, siteId}});
			}
			else {
				this.zoneId = zoneId;
				let projectId = this.projectId;
				let siteId = this.siteId;
				this.$router.push({name: 'Zone', params: {projectId, siteId, zoneId}});
			}
		},
		aqCardZoneChange(zoneId){
			console.log("trying to change zones...")
			let zone = this.zones.find((el) => el.objectId == zoneId);
			if(!zone){
				zone = this.zones.find((el) => el.source && el.source.objectId == zoneId);
				if(!zone){
					throw `No zone found ${zoneId}`
				} else {
					console.log('Found zone ' + zone.name)
				}
			}
			this.zoneId = zone.objectId;
			this.scope = zone.objectId;
			let projectId = this.projectId;
			let siteId = this.siteId;
			this.$router.push({name: 'Zone', params: {projectId, siteId, zoneId}});
		},
		setCustomTimePeriod() {
			console.log("trying to set custom range")

			let startVal = this.$refs.dpStart.value;
			let endVal = this.$refs.dpEnd.value
			
			if(!startVal || !endVal)
				return;

			console.log("both dates exist", startVal, endVal)

			let startISO = Date.parse(startVal);
			let endISO = Date.parse(endVal);
			let start = moment(startISO);
			let end = moment(endISO);

			if(start > end) {
				this.snackMsg = 'Starting date greater than the ending date';
				this.snackbar = true;
			}
			else if((end.diff(start,'day')) > 60) {
				this.snackMsg = 'Time period exceeds 60 days';
				this.snackbar = true;
			}
			else {
				this.tpCustomStart = startISO;
				this.tpCustomEnd = endISO;
				this.resetMeasurements();
				this.loadSite();
			}
        },
		setSensorCounts(zones,measurements){
			zones.forEach(z => {
				if(z.name != "Overview") {
					measurements.forEach(cm => {
						if(z.id == cm.zone?.id) {
							let count = cm.childMeasurements?.length;
							let equipmentCount = z.scoreEQ?.childMeasurements?.length;
							if(equipmentCount)
								cm.sensorCount = count + equipmentCount;
							else
								cm.sensorCount = count;
							// console.log('counts: ', count, equipmentCount);
						}
					})
				}
			})
			return measurements;
		},
		setMeasurements(zones,measurements){
			measurements.forEach(m => {
				if(m.type == 'scoreAF') {
					// if(m.childMeasurements)
					// 	this.sortMeasurements(m.childMeasurements);
					
					// if(zones && m.childMeasurements)
					// 	m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)

					this.measurementsAF = m;
					this.helpMeasurements.push(m);
				}
				if(m.type == 'scoreAQ') {
					// if(m.childMeasurements)
					// 	this.sortMeasurements(m.childMeasurements);

					// if(zones && m.childMeasurements)
					// 	m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)

					this.measurementsAQ = m;
					this.helpMeasurements.push(m);
				}
				if(m.type == 'scoreOW') {
					// if(m.childMeasurements)
					// 	this.sortMeasurements(m.childMeasurements);
					
					// if(zones && m.childMeasurements)
					// 	m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)

					this.measurementsOW = m;
					this.helpMeasurements.push(m);
				}
				if(m.type == 'scoreEQ') {
					// if(m.childMeasurements)
					// 	this.sortMeasurements(m.childMeasurements);

                    // if(zones && m.childMeasurements)
					// 	m.childMeasurements = this.setSensorCounts(zones, m.childMeasurements)
                        
					this.measurementsEQ = m;
					this.helpMeasurements.push(m);
				}
			});
		},
		sortAndSetChildMeasurements(childMeasurements, measurements){
			let cmf = measurements.filter((el) => childMeasurements.find((el2) => el2.objectId == el.objectId))
            //- console.log("cmf", cmf)
			cmf.forEach((el) => {
				if(el.childPoints?.length == 1){
					if(el.childPoints[0].functions?.length >= 1){
						el.writable = {
							endpoint: `/api/points/${el.childPoints[0].uuid}/runFunction`,
							function:  el.childPoints[0].functions
						}
					}
				}
			})
			return cmf.sort((a, b) => {
				// Handle undefined or null names
				const nameA = a.name || '';
				const nameB = b.name || '';
				return nameA.localeCompare(nameB, undefined, {numeric: true, sensitivity: 'base'})
			})
		},
		sortMeasurements(measurements){
			measurements.sort(function(a,b){ 
				// Handle undefined or null names
				const nameA = a.name || '';
				const nameB = b.name || '';
				return nameA.localeCompare(nameB, undefined, {numeric: true, sensitivity: 'base'})
			})
		},
		resetMeasurements() {
			this.zoneId = this.$route.params.zoneId;
			this.measurementsAF = null;
			this.measurementsAQ = null;
			this.measurementsOW = null;
			this.measurementsEQ = null;
			this.helpMeasurements = [];
		},
		setBreadCrumbsAndTitle() {
			this.zoneCrumbs = [];
			this.pageTitle = {
				id: this.siteId,
				score: this.site.scoreOA?.curScore,
				title: this.site.name,
			}
		},
		async fetchAlerts(){
			try {
				if (!this.siteId) return;
				let results = await client.robustQuery(`/api/sites/${this.siteId}/alerts?isActive=true`);
				if(results.alerts.length > 0) {
					results.alerts.sort((a, b) => (a.alertConfig.alertType > b.alertConfig.alertType) ? 1 : -1);
					this.notifications.alerts = results.alerts;
					this.getAlertCssClass();
				}
			} catch (error) {
				console.error(error);
			}
		},
		async loadSite() {
			try {
				let userAccess = false;
				if (this.$store.state.projects.length <= 0) {
					this.loadingProjects = true;
				} else {
					this.loadingProjects = false;
				}
				console.log("currentView", this.currentView)
				this.hasAccess = true;
				if (!this.projectId && this.$store.state.projects.length > 0) {
					this.projectId = this.$store.state.projects[0].objectId;
				}

				if (['selection', 'create', 'dashboard'].includes(this.currentView)) {
					if (!(this.$store.state.sites && this.$store.state.sites.length) && this.projectId) {
						try {
							const sitesRes = await client.robustQuery('/api', { slim: true });
							const pid = this.projectId;
							const allowed = sitesUserCanAccess(sitesRes.sites, this.$store.state.user, pid);
							this.$store.commit('setSites', allowed);
						} catch (error) {
							console.error('Failed to fetch sites for dashboards:', error);
						}
					}
					return;
				}

				if (!this.siteId && this.projectId) {
					try {
						const sitesRes = await client.robustQuery('/api', { slim: true });
						const pid = this.projectId;
						const allowed = sitesUserCanAccess(sitesRes.sites, this.$store.state.user, pid);
						this.$store.commit('setSites', allowed);
						const first = firstAccessibleSite(allowed, this.$store.state.user, pid);
						if (first) {
							this.siteId = first.objectId;
							this.site = {
								objectId: first.objectId,
								name: first.name,
								commanderLicenseId: first.commanderLicenseId || null,
								project: sitesRes.project || first.project || null,
								canBeScheduled: first.canBeScheduled || false
							};
						}
					} catch (error) {
						console.error('Failed to fetch default site for navbar:', error);
					}
				}
				console.log("loadSite?", this.siteId)
				if (!this.siteId) return;
				
				// For the legacy monitoring view, load full site data.
				for (let p of this.$store.state.projects) {
					if (p.objectId == this.projectId) {
						userAccess = true;
						break;
					}
				}
				if (!userAccess) {
					this.hasAccess = false;
					return;
				} else {
					this.hasAccess = true;
				}
				if(this.zoneId){
					this.scope = this.zoneId;
				} else {
					this.scope = "overview";
				}
				let zoneRes = await client.robustQuery('/api/zones', {siteId: this.siteId, withMeasurements: true});
				let measurementsRes = await client.robustQuery('/api/measurements', {siteId: this.siteId, zoneId: this.zoneId});
                this.site = await useGetSite(this.siteId)
                this.ready = true;
				this.$store.commit("setSite", this.site);
				this.$store.commit('setProject', this.site.project)
				this.zones = zoneRes.results;
				this.scopeZones = zoneRes.results.sort((a, b) => {
					// Handle undefined or null names
					const nameA = a.name || '';
					const nameB = b.name || '';
					return nameA.localeCompare(nameB);
				});
				this.scopeZones.unshift({'name':'Overview','objectId':'overview'});
                 const { results: floors } = await client.robustQuery(`/api/sites/${this.siteId}/floors`);
                this.floors = floors;
                if(this.floors.length > 0){
                    this.floorPlanViewAvailable = true;
                }
                //- console.log('measurementRes', measurementsRes);

				zoneRes.results.forEach(el => {
					this.zoneTracker[el.objectId] = el.name;
					if(el.source)
						this.zoneTracker[el.source.objectId] = el.name;
				})

				this.setBreadCrumbsAndTitle();
				this.setMeasurements(zoneRes.results,measurementsRes.results);
				this.fetchAlerts();
				this.startOnboardingTooltips();

				this.scoreHelp = {
					overallCurScore: this.site.scoreOA?.curScore,
					measurements: this.helpMeasurements,
					key: this.helpMeasurements.length,
				}

				this.$nextTick(() => {
					let sn = document.querySelectorAll('.sidenav');
					window.M.Sidenav.init(sn);

					let sl = document.querySelectorAll('select');
					window.M.FormSelect.init(sl);

					let dp = document.querySelectorAll('.datepicker');
					let dpOptions = {
						minDate: new Date(this.site.firstDataDate || this.site.createdAt),
						maxDate: new Date(),
						autoClose: true,
						format: 'mmm d, yyyy',
					}
					window.M.Datepicker.init(dp, dpOptions);

					let dd = document.querySelectorAll('.dropdown-trigger');
					let dropOptions = { coverTrigger: false }
					window.M.Dropdown.init(dd,dropOptions);

					let mod = document.querySelectorAll('.modal');
                    window.M.Modal.init(mod, {dismissible: false});
					
				})
			} catch (error) {
				console.error(error);
				window.M.toast({html: 'Cannot Load Site'});
			}
		}
	},
	computed: {
		dateRange(){
			if(this.timePeriod && this.timePeriod!== "custom")
				return `${moment().startOf(this.timePeriod).format('MMM D')} - ${moment().format('MMM D, YYYY')}`
			else
				return ''
		},
		currentProjectName() {
			// Get current project from store or route params
			const projectId = this.$route.params.projectId;
			if (projectId && this.$store.state.projects.length > 0) {
				const currentProject = this.$store.state.projects.find(p => p.objectId === projectId);
				return currentProject ? currentProject.name : 'Project';
			}
			// Fallback to store project or default
			const project = this.$store.state.project;
			return project ? project.name : 'Project';
		},
		shouldShowNavbar() {
			// Show navbar for dashboard management views without site dependency
			console.log("currentView", this.currentView)
			console.log("loadingProjects", !this.loadingProjects)
			if (['selection', 'create', 'dashboard'].includes(this.currentView)) {
				return !this.loadingProjects;
			}
			// For monitoring view, use original condition
			return this.hasAccess && !this.loadingProjects;
		},
		navbarSiteId() {
			if (['selection', 'create', 'dashboard'].includes(this.currentView)) {
				return this.$route.query.siteId || this.siteId || null;
			}
			return this.siteId;
		},
		

	},
	mounted() {
		// Determine initial view based on route parameters
		if (this.dashboardId) {
			// If dashboardId is provided, load the specific dashboard
			this.loadDashboard();
		} else {
			// Show dashboard selection view
			this.currentView = 'selection';
			// Call loadSite after setting currentView
			this.loadSite();
		}
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		$route(to, from){
			// Update dashboardId and siteId when route changes
			this.dashboardId = to.params.dashboardId || null;
			this.siteId = to.query.siteId || to.params.siteId || null;
			
			if (this.dashboardId) {
				this.currentView = 'dashboard';
				this.loadDashboard();
			} else {
				this.currentView = 'selection';
				this.selectedDashboard = null;
				this.isNewDashboard = false;
			}
			
			this.resetMeasurements();
			this.loadSite();
		},
		'$store.state.projects': {
			handler() {
				this.resetMeasurements();
				this.loadSite();
			}
		}
	}
};
</script>
<style lang="sass" scoped>
	.no-flex
		display: block
	.v-app
		background: transparent
		.v-application--wrap
			display: block
	.modal-trigger
		&:hover
			.main-donut
				background: rgba(255, 255, 255, 0.1)
				-webkit-box-shadow: 0px 0px 10px 5px rgba(255, 255, 255, 0.2)
				box-shadow: 0px 0px 10px 5px rgba(255, 255, 255, 0.2)
				border-radius: 50%
	.siteLink
		color: var(--app-primary-txt)
		font-size: 28px
		line-height: inherit
		&:hover
			text-decoration: underline
	.date-range
		color: var(--app-tertiary-txt)
		text-align: right
		opacity: 1
</style>